import { Component, OnInit, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Router, ActivatedRoute } from '@angular/router';
import { ShapeSearchService } from './shapesearch.service';
import { ProjectDataService } from '../shared/dataservice.service';
import { ProjectsService } from '../projects/projects.service';
import * as Materialize from 'angular2-materialize/dist/index';
import { ProjectsInfoService } from '../projectinfo/projectinfo.service';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { NavbarService } from '../navbar/navbar.service';
import * as globals from '../globals';
import { SharedService } from '../shared/shared.service';
import { UtilsService } from '../shared/utils.service';
import { GetFileTypeService } from '../shared/getFileType/get-file-type.service';
import { BackButtonComponent } from '../shared/inAppBack/back-button/back-button.component';


declare var openNewBrowserWindow: any;
declare var openNewtwoViewsWindow: any;

@Component({
  selector: 'app-shapesearch',
  templateUrl: 'shapesearch.component.html',
  styleUrls: ['shapesearch.component.css'],
  providers: [ProjectsService, ShapeSearchService, ProjectsInfoService, SharedService, GetFileTypeService]
})
export class ShapesearchComponent implements OnInit {

  project: any;
  private bucketname = globals.BUCKETNAME;
  searchingforshapes = false;
  noresults = false;
  noresultsmessage: string = 'No similar parts found';
  novizseekguid = false;
  timer: any;
  ssresults: any;
  ssprojects: any;
  planid: string;
  tenantid: any;
  tenanturl: string = '';
  materialArray: any = [];
  materialDict: any = {};
  ownerArray: any = [];
  ownerDict: any = {};
  customerArray: any = [];
  customerDict: any = {};
  result: any = {};
  statusArray: any = ['OPEN', 'WIP', 'REVIEW', 'APPROVED', 'MADE'];
  _projectDataService: any;
  errorMessage: string;
  mr_project: any;
  modalCompareProjectsAction = new EventEmitter<string | MaterializeAction>();

  constructor(private router: Router,
              private shapeSearchService: ShapeSearchService,
              private projectsService: ProjectsService,
              private projectDataService: ProjectDataService,
              private _ProjectsInfoService: ProjectsInfoService,
              public navService: NavbarService,
              private route: ActivatedRoute,
              private utilsService: UtilsService,
              private getFileTypeService: GetFileTypeService,
              private service: SharedService) {
    this._projectDataService = projectDataService;
  }

  ngOnDestroy() {
    this.modalCompareProjectsAction.emit({ action: 'modal', params: ['close'] });
  }


  ngOnInit() {
    this.tenantid = localStorage.getItem('mr_tenantid');
    this.planid = localStorage.getItem('mr_planid');

    let sProject = localStorage.getItem('mr_project');

    this.mr_project = JSON.parse(sProject);

    this.service.getCorporateInfo().subscribe(
      data => {
        let jdata = JSON.parse(data);
        this.customerArray = jdata.customers;
        this.materialArray = jdata.materials;
        this.ownerArray = jdata.owners;

        let projectid = +this.route.snapshot.paramMap.get('id');

        this.service.getProjectDetailsById(projectid).subscribe(
          data => {
            let parseddata = JSON.parse(data);
            console.log('PARSEDDATA:', parseddata);
            this.project = parseddata.project;

            let filenamenoext = this.project.filename.replace(/\.[^/.]+$/, '');
            if (!filenamenoext) {
              filenamenoext = ' ';
            }
            this.project.filenamenoext = filenamenoext;

            for (let i = 0; i < this.materialArray.length; i++) {
              this.materialDict[this.materialArray[i].id] = this.materialArray[i].name;
            }

            for (let i = 0; i < this.ownerArray.length; i++) {
              this.ownerDict[this.ownerArray[i].id] = this.ownerArray[i].email;
            }

            for (let i = 0; i < this.customerArray.length; i++) {
              this.customerDict[this.customerArray[i].id] = this.customerArray[i].name;
            }

            if (typeof this.planid == 'undefined' || this.planid === '') {
              this.planid = '1';
            }

            if (this.planid === '3') {
              this.tenanturl = globals.GOVTENANTURL;
            } else {
              this.tenanturl = globals.TENANTURL;
            }

            // Determine the Model Type to show - based on the file extension
            this.project.modeltype = this.utilsService.getModelName(this.project.modeltype_id);
            if (this.project.modeltype != 0) {
              this.project.thumbnail = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + this.project.id + '/' + filenamenoext + '_320x240.png';
            } else {
              let ext = this.project.extension.toLowerCase();
              console.log('EXTENSION:', ext);
              this.project.thumbnail = this.getFileTypeService.returnFileTypeExtensionURLAppend96(ext);
            }

            console.log('GUID:', this.project.vizseek_guid);
            this.shapeSearch();
          },
          error => {
            console.log('getProjectDetailsById error: ', error);
          }
        );
      },
      error => {
        console.log('getCorporateInfo error: ', error);
      }
    );
  }

  shapeSearch() {
    if (this.project.vizseek_guid === 'FailedToUpload' || !this.project.vizseek_guid || this.project.vizseek_guid === '0') {
      this.searchingforshapes = false;
      this.noresults = true;
      this.noresultsmessage = 'This part does not have a valid shape search ID';
      console.log('Invalid VizSeek GUID');
      return;
    }

    this.searchingforshapes = true;

    this.shapeSearchService.shapeSearch(this.project.vizseek_guid, this.tenantid)
      .subscribe(
      data => {
        // console.log('PROJECTS data:', data);
        if (Object.keys(data).length === 0) {
          this.searchingforshapes = false;
          this.noresultsmessage = 'No similar parts found';
          this.noresults = true;
          console.log('NO RESULTS');
        } else {
          // TODO: Account for a response of 'Process exited before completing request'
          //      or have API Gateway massage this response
          // this.shapesearchresults = JSON.parse(data);
          console.log('RESULTS:', data);
          this.ssresults = data;

          this.shapeSearchService.ssGetProjects(this.tenantid, data)
            .subscribe(
            data => {
              // console.log('ssGetProjects data:', data);
              if (Object.keys(data).length === 0) {
                this.searchingforshapes = false;
                this.noresultsmessage = 'No similar parts found';
                this.noresults = true;
                console.log('NO RESULTS');
              } else {
                // TODO: Account for a response of 'Process exited before completing request'
                //      or have API Gateway massage this response
                // this.shapesearchresults = JSON.parse(data);
                // console.log('RESULTS:', data);
                this.searchingforshapes = false;
                this.noresults = false;
                let dataobj = JSON.parse(data);
                let dataobjArray = dataobj.results;
                let projectsVizseekGUID = this.project.vizseek_guid;
                for (let key = 0; key < dataobjArray.length; key++) {
                  if (dataobjArray[key].vizseek_guid === projectsVizseekGUID) {
                    dataobjArray.splice(key, 1);
                    continue;
                  }
                }
                this.ssprojects = dataobjArray;
                console.log('ssprojects', this.ssprojects);
                this.processResults(projectsVizseekGUID);
              }
            },
            error => {
              this.searchingforshapes = false;
              this.noresults = true;
            });

          // Not sure why we were getting all the project info again...so I commented it out!

          // this.service.getProjectDetailsById(this.project.id).subscribe(
          //   data => {
          //     data = data.split('\\\"').join('\"');
          //     // data = data.slice(1, -1);
          //     let projectArray = JSON.parse(data);
          //     this.project = {};
          //     this.project = projectArray.project;
          //     this.project.id = this.mr_project.id;
          //     this.project.name = this.mr_project.name;
          //     this.project.thumbnail = this.mr_project.thumbnail;
          //     let filenamenoext = this.mr_project.filename.replace(/\.[^/.]+$/, '');
          //     if (!filenamenoext) {
          //       filenamenoext = ' ';
          //     }
          //     this.project.filenamenoext = filenamenoext;
          //   },
          //   error => {
          //   });
        }
      },
      error => {
        this.searchingforshapes = false;
        this.noresultsmessage = 'No similar parts found';
        this.noresults = true;
      });
  }

  processResults(projectsVizseekGUID) {
    // for (var key in this.ssprojects) {
    for (let key = 0; key < this.ssprojects.length; key++) {
      // Determine the status of the model file to show
      // if (this.ssprojects.hasOwnProperty(key)) {
      // console.log('KEY:', key, 'filename:', this.ssprojects[key].filename);
      let filenamenoext = this.ssprojects[key].filename.replace(/\.[^/.]+$/, '');
      if (!filenamenoext) {
        filenamenoext = ' ';
      }
      this.ssprojects[key].filenamenoext = filenamenoext;
      this.ssprojects[key].thumbnail = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + this.ssprojects[key].id + '/' + filenamenoext + '_320x240.png';
      this.ssprojects[key].thumbnail2 = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + this.ssprojects[key].id + '/' + filenamenoext + '_100x75.png';
      if (this.ssprojects[key].number == 'undefined' || this.ssprojects[key].number == '' || this.ssprojects[key].number == null) {
        this.ssprojects[key].number = '-';
      }
      if (this.ssprojects[key].revision == 'undefined' || this.ssprojects[key].revision == '' || this.ssprojects[key].revision == null) {
        this.ssprojects[key].revision = '-';
      }
      // let val = this.ssprojects[key];

      // Populate the score
      let score = this.getScore(this.ssprojects[key].vizseek_guid);
      this.ssprojects[key].score = score;
      // console.log('VIZ:', this.ssprojects[key].vizseek_guid);
      // console.log('SCORE:', score);
      let percentage = (1 - score) * 100;
      // console.log('PERCENT:', percentage);
      // console.log('PERCENT round:', percentage.toFixed(1));
      this.ssprojects[key].percentage = percentage.toFixed(1);
      // }
    }

    // Sort the results
    this.ssprojects.sort(function (a, b) {
      return parseFloat(a.score) - parseFloat(b.score);
    });
  }

  getScore(vizseekguid) {

    for (let i = 0; i < this.ssresults.length; i++) {
      if (this.ssresults[i].FileUID == vizseekguid) {
        return this.ssresults[i].ShapeResult.Score;
      }
    }

    return null;
  }

  updateShapeSearch() {
    this.searchingforshapes = false;
  }

  onRefresh() {
    this.shapeSearch();
  }

  onBack() {
    this.router.navigate(['/projects']);
  }

  editRow(control) {
    document.getElementById(control).style.display = 'none';
    document.getElementById(control + 'Edit').style.display = 'block';

    document.getElementById(control + 'Pencil').style.display = 'none';
    document.getElementById(control + 'Apply').style.display = 'block';
    document.getElementById(control + 'Cancel').style.display = 'block';
  }

  cancelEditRow(control) {
    document.getElementById(control).style.display = 'block';
    document.getElementById(control + 'Edit').style.display = 'none';
    (<HTMLInputElement>document.getElementById(control + 'Edit')).value = this.project[control];

    document.getElementById(control + 'Pencil').style.display = 'block';
    document.getElementById(control + 'Apply').style.display = 'none';
    document.getElementById(control + 'Cancel').style.display = 'none';
  }

  saveRow(control) {
    document.getElementById(control).style.display = 'block';
    document.getElementById(control + 'Edit').style.display = 'none';
    let controlValue = control.split('~');
    this.project[controlValue[0]] = (<HTMLInputElement>document.getElementById(control + 'Edit')).value;

    document.getElementById(control + 'Pencil').style.display = 'block';
    document.getElementById(control + 'Apply').style.display = 'none';
    document.getElementById(control + 'Cancel').style.display = 'none';

    // To implement a code to get their actual ids by collecting arrays in dictionary objects
    Materialize.toast('Project property updating...', 1000);
    let updateProjectDetails = {
      name: this.project.name,
      number: this.project.number,
      revision: this.project.revision,
      description: this.project.description,
      material_id: this.project.material_id,
      assigned_id: this.project.assigned_id,
      customer_id: this.project.customer_id,
      // status_id: this.project.status,
      operations: this.project.operations,
      set_time: this.project.actual_set_time,
      run_time: this.project.actual_run_time,
      cost: this.project.actual_cost
    };
    this.projectsService.updateProject(this.project.id, updateProjectDetails)
      .subscribe(
      data => {
        console.log('Project added to DB');
        // let projectdata = JSON.parse(data);
        Materialize.toast('Project property updated.', 1000);
        this._projectDataService.setForceUpdateBool(true);
      },
      error => {
        this.errorMessage = <any>error;
        console.error('getProjects() error:', this.errorMessage);
      });
  }

  openInViewer(id: string, name: string) {
    // Build the URL
    let hwfurl = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + id + '/' + name + '.hwf';
    console.log('openInViewer() URL: ', hwfurl);
    // openNewBrowserWindow('/#/viewer', hwfurl);
    openNewBrowserWindow('/#/viewer', hwfurl);
  }

  compareViews(id: string, name: string) {
    let hwfurl1 = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + this.project.id + '/' + this.project.filenamenoext + '.hwf';
    let hwfurl2 = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + id + '/' + name + '.hwf';

    openNewtwoViewsWindow('/#/compareview', hwfurl1, hwfurl2);
  }

  openModalCompareProjects(selectedresult) {
    this.modalCompareProjectsAction.emit({ action: 'modal', params: ['open'] });
    this.result = selectedresult;
    console.log('ownerDict : ', this.ownerDict);
    console.log('ownerDict : ', this.customerDict);
    console.log('ownerDict : ', this.materialDict);
    console.log('Result : ', this.result);
    console.log('project : ', this.project);

  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/shapesearch/shapesearch.component.ts